import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { FeatureFlagService } from './feature-flag.service';

/**
 * #77 — `canMatch` guard that lets a route match ONLY when the Knowledge Centre flag is ON.
 *
 * Used to swap `/learn` between the new Knowledge Centre and the legacy portal WITHOUT changing the
 * URL: the flagged route (KnowledgeHubComponent) is declared FIRST with this guard, then the bare
 * legacy `/learn` (LearnComponent) as the OFF fallback. When the flag is OFF this guard returns
 * false, the flagged route is skipped, and the router falls through to the legacy route — so default
 * behaviour is unchanged. The flag is already loaded at bootstrap (APP_INITIALIZER), so this is a
 * synchronous read.
 */
export const knowledgeCentreOnGuard: CanMatchFn = (): boolean =>
  inject(FeatureFlagService).knowledgeCentreEnabled;

/**
 * P2P-29 (F0.4) — `canMatch` guard that lets a route match ONLY when the Notes flag is ON.
 *
 * Used on the `/note` scaffolding: the indexable variant is declared FIRST with this guard, then a bare
 * `/note` fallback (same placeholder component, `noindex`) so the route ALWAYS resolves — flag OFF still
 * renders the placeholder (unlinked, noindex) rather than 404-ing, which is what lets Dry Run A run a
 * real cycle on production without exposing Notes. The flag is loaded at bootstrap (APP_INITIALIZER), so
 * this is a synchronous read.
 */
export const notesEnabledOnGuard: CanMatchFn = (): boolean =>
  inject(FeatureFlagService).notesEnabled;
